import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../context/DataContext'; // Import the hook
import { Footer } from '../component/Footer';
import { Header } from '../component/Header';

const RestaurantsPage = () => {
  // Get global data from Context
  const { restaurants, categories, loading ,fetchInitialData} = useData();
  
  // Local UI States (Filter & Pagination stay local)
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedOffer, setSelectedOffer] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
useEffect(() => {
    // Only fetch if context is empty
    if (restaurants.length === 0) {
      fetchInitialData();
    }
  }, []);
  // Filter Logic
  const filteredRestaurants = restaurants.filter((res) => {
    const matchesName = res.name.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory === 'All' || 
      res.restaurant_categories?.some(rc => rc.categories?.name === selectedCategory);
    const matchesOffer = selectedOffer === 'All' || 
      (selectedOffer === '50+' ? res.percent_off >= 50 : res.percent_off >= parseInt(selectedOffer));

    return matchesName && matchesCategory && matchesOffer;
  });

  // Pagination Logic
  const totalPages = Math.ceil(filteredRestaurants.length / itemsPerPage);
  const currentItems = filteredRestaurants.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="min-h-screen bg-[#FFFDE1] font-sans text-zinc-900">
      <Header/>

      <header className="px-16 pt-8 pb-12 max-w-8xl mx-auto">
        <h1 className="text-5xl font-bold tracking-tight uppercase mb-10">
          Filter <span className="text-[#ef3a5d]">Partners</span>
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 bg-white p-6 rounded-[1rem] border border-zinc-200 shadow-sm">
          <div className="flex flex-col gap-2">
            <label className="text-[9px] font-bold uppercase tracking-widest text-zinc-400 ml-2">Search</label>
            <input
              type="text"
              placeholder="RESTAURANT NAME..."
              value={searchQuery}
              onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
              className="w-full bg-zinc-50 border border-zinc-100 rounded-xl px-4 py-3 text-[10px] font-bold uppercase focus:outline-none focus:border-[#ef3a5d]"
            />
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-[9px] font-bold uppercase tracking-widest text-zinc-400 ml-2">Category</label>
            <select
              value={selectedCategory}
              onChange={(e) => { setSelectedCategory(e.target.value); setCurrentPage(1); }}
              className="w-full bg-zinc-50 border border-zinc-100 rounded-xl px-4 py-3 text-[10px] font-bold uppercase focus:outline-none appearance-none cursor-pointer"
            >
              <option value="All">All Categories</option>
              {categories.map((cat, i) => (
                <option key={i} value={cat.name}>{cat.name}</option>
              ))}
            </select>
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-[9px] font-bold uppercase tracking-widest text-zinc-400 ml-2">% Discount</label>
            <select
              value={selectedOffer}
              onChange={(e) => { setSelectedOffer(e.target.value); setCurrentPage(1); }}
              className="w-full bg-zinc-50 border border-zinc-100 rounded-xl px-4 py-3 text-[10px] font-bold uppercase focus:outline-none appearance-none cursor-pointer"
            >
              <option value="All">Any Offer</option>
              <option value="10">10% or more</option>
              <option value="20">20% or more</option>
              <option value="30">30% or more</option>
              <option value="50+">50% Exclusive</option>
            </select>
          </div>

          <div className="flex items-end">
            <button 
              onClick={() => { setSearchQuery(''); setSelectedCategory('All'); setSelectedOffer('All'); }}
              className="w-full bg-zinc-900 text-white py-3 rounded-xl text-[10px] font-bold uppercase tracking-widest hover:bg-[#ef3a5d] transition-colors"
            >
              Clear Filters
            </button>
          </div>
        </div>
      </header>

      <main className="px-16 pb-24 max-w-8xl mx-auto overflow-hidden">
        {loading ? (
          <div className="text-center py-20 uppercase font-bold tracking-widest text-zinc-400 animate-pulse">Syncing Database...</div>
        ) : (
          <div className="bg-white rounded-[1rem] border border-zinc-200 shadow-sm overflow-x-auto">
    
    {/* 3. The table MUST have a min-width to force scrolling on small screens */}
    <table className="w-full text-left border-collapse min-w-[600px]">
      <thead>
        <tr className="border-b border-zinc-100 bg-zinc-50/50">
          <th className="px-8 py-6 text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-400">Partner</th>
          <th className="px-8 py-6 text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-400">Categories</th>
          <th className="px-8 py-6 text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-400 text-right">% Off</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-zinc-50">
        {currentItems.map((restaurant) => (
          <tr key={restaurant.id} className="hover:bg-[#FFFDE1]/50 transition-colors">
            <td className="px-8 py-6 whitespace-nowrap">
              <span className="font-bold uppercase tracking-tight text-lg">{restaurant.name}</span>
            </td>
 <td className="px-8 py-6">
                      <div className="flex flex-wrap gap-2">
                        {restaurant.restaurant_categories?.length === 0 ? (
                           <span className="text-[9px] font-bold uppercase tracking-widest text-zinc-300">-</span>
                        ) : (
                          restaurant.restaurant_categories?.map((rc, idx) => (
                            <span key={idx} className="text-[9px] font-bold uppercase tracking-widest text-[#ef3a5d] bg-[#ef3a5d]/5 px-2 py-1 rounded-md border border-[#ef3a5d]/10">
                              {rc.categories?.name}
                            </span>
                          ))
                        )}
                      </div>
                    </td>           <td className="px-8 py-6 text-right whitespace-nowrap">
              <span className="text-xl font-black italic text-zinc-900">{restaurant.percent_off}% OFF</span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
        )}

        {!loading && totalPages > 1 && (
          <div className="flex items-center justify-center mt-8 gap-4">
            <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} className="px-6 py-2 rounded-xl bg-white border border-zinc-200 text-[10px] font-bold uppercase disabled:opacity-30">Prev</button>
            <span className="text-[10px] font-bold text-zinc-400 uppercase tracking-widest">{currentPage} / {totalPages}</span>
            <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => p + 1)} className="px-6 py-2 rounded-xl bg-white border border-zinc-200 text-[10px] font-bold uppercase disabled:opacity-30">Next</button>
          </div>
        )}
      </main>
      <Footer/>
    </div>
  );
};

export default RestaurantsPage;